
import InitiationPage from '../components/InitiationPage/InitiationPage';

const Initiation = () => {
  return <InitiationPage />;
};

export default Initiation;
